import { CompanyCreateContent } from "../../features/companyWorkspace";

function CompanyNewScreen() {
  return <CompanyCreateContent />;
}

export default CompanyNewScreen;
